import { Sentry } from '../config/sentry'

export const logError = (errorData) => {
    if (errorData.error && errorData.message) {
        console.error(
            `[${errorData.error}] ${errorData.message}`,
            errorData.details ?? ""
        )
        // Send to Sentry as a captured message with context
        Sentry.withScope(scope => {
            scope.setTag("error_type", errorData.error)
            scope.setExtra("message", errorData.message)
            scope.setExtra("details", errorData.details ?? null)
            Sentry.captureMessage(`[${errorData.error}] ${errorData.message}`, 'error')
        })
    } else {
        console.error("Unexpected error format:", errorData)
        Sentry.captureMessage("Unexpected error format received", 'warning')
    }
}

export const formatError = (error) => {
    // Also capture actual JS exceptions (network failures, etc.)
    Sentry.captureException(error)
    return {
        error: "UnexpectedError",
        message: error.message || "Unknown error",
        details: error.stack || null,
    }
}

